var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "divLine" },
      [
        _c("svg-icon", {
          staticStyle: { "margin-right": "0.05rem" },
          attrs: { iconClass: "time" },
        }),
        _vm._v(" 3间 高级客房 Superior Room 双早 加个果盘 "),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "divLine" },
      [
        _c("svg-icon", {
          staticStyle: { "margin-right": "0.05rem" },
          attrs: { iconClass: "time" },
        }),
        _vm._v(
          " 3间 普通客房 Superior Room 单早 希望可以靠窗比较一下Standard Room "
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "divLine" }, [
      _c("span", [_vm._v("2020-06-20")]),
      _vm._v(" 入住  "),
      _c("span", [_vm._v("2020-06-23")]),
      _vm._v("  离店 "),
      _c("span", [_vm._v(" 3晚 ")]),
      _vm._v("  "),
      _c("span", [_vm._v("5个成人 2个儿童")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }